/**
 * Created by agengmaulana on 5/16/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'
import {observer} from 'mobx-react'
import {observable} from 'mobx'
import PropTypes from 'prop-types'

// @observer
export default class List_Report_Abuse extends React.Component{


    constructor(props) {
        super(props);
    }
    render(){
        // let checkactived = datastore.valueLaporkan ? 'check' : ''
        const {dataStore} = this.props;

        return(
            <div className={styles.cmt_dropdown_menu} onMouseLeave={this.close}>
                <p className={styles.cmt_bold}>Silakan berikan laporan Anda terkait komentar ini :</p>
                <form onSubmit={this.props.submitLaporkan} >
                    {

                        dataStore.ListReport.map(
                            (list,i) =>
                                <div key={i+1} className={styles.cmt_checkbox}>
                                    <label htmlFor={list.replace("_", " ")} className={styles.icon} >
                                        <input type="radio" name="jwbn" onClick={this.props.change} value={i+1} id={list.replace("_", " ")} />
                                        <span> {list.replace("_", " ")}</span>
                                    </label>
                                </div>
                        )
                    }

                    <div className={styles.cmt_text_right+' '+styles.cmt_mt15}>
                        {/*<a href="javascript:void(0);" className={styles.btn+' '+styles.btn_grey+' '+styles.batal} onClick={this.props.close}>BATAL</a>*/}
                        <input className={styles.cmt_btn} type="submit" value="Kirim"  />
                    </div>
                </form>
            </div>
        )
    }


    close=()=>{
        this.props.closeLapor()
    }
}
List_Report_Abuse.propTypes = {
    dataStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./static/src/component/comment_report_abuse/comment_sub_report.js